'use client';

import { useTranslations } from 'next-intl';

/**
 * Small festive min-stay hint shown above a calendar when the selected or
 * hovered check-in carries a minimum stay > 1 (D31, doc 81 §12.4 E).
 * Renders nothing for normal (1-night) days. `tone` adapts the palette to the
 * calendar's background: `dark` for the glass per-room calendars (white text),
 * `light` for the sidebar filter / modal (dark text).
 */
export function MinStayNotice({
  nights,
  tone = 'light',
}: {
  nights: number;
  tone?: 'dark' | 'light';
}) {
  const t = useTranslations('rooms');
  if (nights <= 1) return null;

  return (
    <div
      className={
        tone === 'dark'
          ? 'mb-1.5 text-center text-xs font-medium text-[#e9c46a]'
          : 'mb-1.5 text-center text-xs font-medium text-[#9a6a1a] bg-[#c79a3a]/10 rounded py-1 px-2'
      }
      style={tone === 'dark' ? { textShadow: '1px 1px 3px rgba(0,0,0,0.6)' } : undefined}
    >
      {t('minStayNotice', { nights })}
    </div>
  );
}
